module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('purchases'), _vm._v(" "), _c('h2', {
    staticClass: "title is-2 centered"
  }, [_vm._v("Tickets")]), _vm._v(" "), _c('tickets'), _vm._v(" "), _c('about')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88b5405a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 102
// module chunks = 2